<template>
  <div id="app">
    <Alert ref="ApplicationAlert" />

    <b-container fluid style="solid;height: 100%">
      <router-view style="height: 100%" />
    </b-container>
  </div>
</template> 

<script>
import Alert from "@/components/Alert";

export default {
  name: "App",
  components: {
    Alert
  }
};
</script>

<style>
html,
body {
  height: 100%;
  font-size: 0.95em;
  font-family: "Segoe UI", Verdana, Helvetica, Sans-Serif;
  color: #232323;
  background-color: #fff;
  background-color: rgb(227, 234, 242);
  color: rgb(51, 51, 51);
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  max-width: 1024px;
  width: 100%;
  margin: auto;
  height: 100%;
}

.errore {
  color: red;
  font-weight: 700;
  text-align: justify;
}

/* poiret-one-regular - latin */
@font-face {
  font-family: "Poiret One";
  font-style: normal;
  font-weight: 400;
  src: local("Poiret One"), local("PoiretOne-Regular"),
    url("../fonts/poiret-one-v8-latin-regular.woff2") format("woff2"),
    /* Chrome 26+, Opera 23+, Firefox 39+ */
      url("../fonts/poiret-one-v8-latin-regular.woff") format("woff"); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
</style>
